import $ from 'jquery';

export function setupFanChoiceVotingForm(): void {
  $('#DOB').datepicker({
    changeMonth: true,
    changeYear: true,
  });

  if ($('.IsValidEmail').val() === 'false') {
    window.location.hash = '#my-new-hash';
  }
}

setupFanChoiceVotingForm();
